import {
    PATH as HomePath,
    pageName as HomePageName,
    HOME_GA_CATEGORY,
} from './Home/constants';

import {
    BasePaths as PracticePaths,
    pageName as PracticePageName,
    PRACTICE_GA_CATEGORY,
} from './Practice/constants';

import {
    BasePaths as ProfilePaths,
    pageName as ProfilePageName,
    PROFILE_GA_CATEGORY,
} from './profile/ActiveProfile/constants';

import {
    BasePaths as SearchPaths,
    pageName as SearchPageName,
    SEARCH_GA_CATEGORY,
} from './Search/constants';

import {
    PATH as TelehealthProfilePath,
    pageName as TelehealthProfilePageName,
    TELEHEALTH_GA_CATEGORY,
} from './Telehealth/Profile/constants';

export default [
    {
        path: HomePath,
        pageName: HomePageName,
        category: HOME_GA_CATEGORY,
    },

    ...PracticePaths.map(path => ({
        path,
        pageName: PracticePageName,
        category: PRACTICE_GA_CATEGORY,
    })),

    ...ProfilePaths.map(path => ({
        path,
        pageName: ProfilePageName,
        category: PROFILE_GA_CATEGORY,
    })),

    ...SearchPaths.map(path => ({
        path,
        pageName: SearchPageName,
        category: SEARCH_GA_CATEGORY,
    })),

    {
        path: TelehealthProfilePath,
        pageName: TelehealthProfilePageName,
        category: TELEHEALTH_GA_CATEGORY,
    },
];
